/*
* Pipeline Theme
*
* Use this file to add custom Javascript to Pipeline.  Keeping your custom
* Javascript in this fill will make it easier to update Pipeline. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*
*/


(function() {

  // Below are example event listeners.  They listen for theme events that Pipeline
  // fires in order to make it easier for you to add customizations.

  // Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.
  setTimeout(function() {
const starImages = document.querySelectorAll(".star-set-image");
 console.log("Swatch URL:", starImages);
// Add a click event listener to each "star-set-image" element
starImages.forEach((starImage) => {
     console.log("Swatch URL:", starImage);
  starImage.addEventListener("click", (event) => {
    // Get the parent element of the clicked star image
    const parentElement = starImage.parentElement;

    // Get the "swatch-url" attribute value
    const swatchUrl = parentElement.getAttribute("swatch-url");

    jQuery.getJSON('https://2xist.com/' + swatchUrl, function(product) {
  imgsrcs = product.product.images.map(item =>item.src);
      console.log('this hit', imgsrcs )
      const modifiedUrls = imgsrcs.map(url => {
return url;
});
   
     event.target.closest('.product__grid__info').parentElement.querySelector('.product-grid-item__image').setAttribute('hover-img', modifiedUrls.join(', '))
        event.target.closest('.product__grid__info').parentElement.querySelector('.product-grid-item__image').setAttribute('feature-img', modifiedUrls[0])
} );
  });
});
}, 3000); 


  document.addEventListener('theme:variant:change', function(event) {
    // You might use something like this to write a pre-order feature or a
    // custom swatch feature.
    var variant = event.detail.variant;
    var container = event.target;
    if (variant) {
      console.log('Container ———————— ↓');
      console.log(container);
      console.log('Variant —————————— ↓');
      console.log(variant);
      // ... update some element on the page
    }
  });

  document.addEventListener('theme:cart:change', function(event) {
    var cart = event.detail.cart;
    if (cart) {
      console.log('Cart ———————————— ↓');
      let size = null;
      cart.items.forEach((item)  => {
        let sizeVariant = item.options_with_values.find(item => item.name == 'Size');
        if (sizeVariant) {
          if(sizeVariant.value == size) {
            size = sizeVariant.value;
          } else {
                 var cartItems = document.querySelector('.error-message');


// Create a new element to hold the text
  cartItems.classList.remove("hideMe");
            
          }
        }
        
        
      });
      // ... update an app or a custom shipping caluclator
    }
  });
  // Fired when page loads to update header values
  document.addEventListener('theme:cart:init', (e) => {
    console.log('theme:cart:init');
    console.log(e);
  });

  // Debounced scroll listeners.  Up and down only fire on direction changes
  // These events are useful for creating sticky elements and popups.
  document.addEventListener('theme:scroll', e => { console.log(e); });
  document.addEventListener('theme:scroll:up', e => { console.log(e); });
  document.addEventListener('theme:scroll:down', e => { console.log(e); });

  // Debounced resize listener to bundle changes that trigger document reflow
  document.addEventListener('theme:resize', e => { console.log(e); });

  // Locks and unlocks page scroll for modals and drawers
  // These are commented out because firing them will lock the page scroll
  // the lock event must set `detail` to the modal or drawer body so the 
  // scroll locking code knows what element should maintain scoll. 
  // document.dispatchEvent(new CustomEvent('theme:scroll:lock', {bubbles: true, detail: scrollableInnerElement}));
  // document.dispatchEvent(new CustomEvent('theme:scroll:unlock', {bubbles: true}));


  // ^^ Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.

  const hoverElements = document.querySelectorAll('.product-grid-item__image');

hoverElements.forEach((element) => {
  // Add a hover effect by changing the background image URL
  element.addEventListener('mouseover', () => {
    const hoverImg =  element.getAttribute('hover-img')
    const images =  hoverImg.split(', ');
    let image =  null;
    if(images[1].includes('files')) {
       image = images[1]
    } else {
    image = `https://2xist.com//cdn/shop/${images[1]}`
    }
    element.style.backgroundImage = `url('${image}')`;
    
    let timeout;
    let index = 2;
     timeout = setInterval(() => {
       if(index >= images.length) {
         index = 0;
       }
           let image =  null;
           if(images[index].includes('files')) {
       image = images[index]
    } else {
    image = `https://2xist.com//cdn/shop/${images[index]}`
    }
       index++;
       element.style.backgroundImage = `url('${image}')`;
    }, 3000); 
    element.addEventListener("mouseout", () => {
  // Clear the timer if the mouse leaves the element before 3 seconds
  clearTimeout(timeout);
});

  });

  // Restore the default background image when the mouse is no longer hovering
  element.addEventListener('mouseout', () => {
       const feature =  element.getAttribute('feature-img')
    element.style.backgroundImage = `url('${feature}')`;
  });
// Select all elements with the class .tab-link under .section-collection-tabs
const tabLinks = document.querySelectorAll('.section-collection-tabs .tab-link');

// Loop through each tab link and attach a click event listener
tabLinks.forEach(tabLink => {
    tabLink.addEventListener('click', function(event) {
        event.preventDefault(); // Prevent the default behavior of the link
        var url = this.getAttribute('url'); // Get the URL attribute of the clicked tab link
        window.location.href = `/collections/${url}`; // Navigate to the specified URL
    });
});


  

});
})();
